export enum ControlType {
    TEXTFIELD = 1,
    CHECKBOX = 2,
    DROPLIST = 3,
    RADIOBUTTON = 4,
    NUMBER = 5,
    AGE = 6,
    PLACEHOLDER = 7,
    EMAIL = 8,
    OCCUPATION = 9,
    CURRENCY = 10
}
